<template>
  <v-container v-if="!review">
    <v-window v-model="step">
        <div class="text-h4">Do you want to enable Canada Calling?</div>
        <v-radio-group v-model="product.canada_calling">
          <v-radio value="y" label="Yes" />
          <v-radio value="n" label="No" />
          <v-radio value="u" label="I don't know" />
        </v-radio-group>
        <v-text-field
          v-if="product.canada_calling === 'y'"
          maxlength="3"
          counter
          v-model="product.canada_calling_inital"
          label="Initial"
          hint="By initaling, you acccept all responsibilities for fraudulent calls made."
          persistent-hint
        />
        <div class="text-h4">Do you want to enable International Calling?</div>
        <v-radio-group v-model="product.international_calling">
          <v-radio value="y" label="Yes" />
          <v-radio value="n" label="No" />
          <v-radio value="u" label="I don't know" />
        </v-radio-group>
        <v-text-field
          v-if="product.international_calling === 'y'"
          v-model="product.international_calling_inital"
          maxlength="3"
          counter
          label="Initial"
          hint="By initaling, you acccept all responsibilities for fraudulent calls made."
          persistent-hint
        />
    </v-window>
  </v-container>
  <div v-else>
    <ReviewItem
      label="Do you want to enable Canada Calling?"
      :value="product.canada_calling === 'y' ? 'Yes' : 'No'"
    />
    <ReviewItem
      label="Do you want to enable International Calling?"
      :value="product.international_calling === 'y' ? 'Yes' : 'No'"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from 'lodash';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: "InternationalCanadaCalling",
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      step: 1,
      product: {},
    };
  },
  mounted() {
    const vm = this;
    vm.product = _.cloneDeep(vm.getProductInfo());
  },
  methods: {
    ...mapActions([
      "syncFormData",
      "nextSubTab",
    ]),
    sync() {
      this.syncFormData({
        mainKey: this.getProductIdSelected,
        data: _.cloneDeep(this.product),
      });
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
  },
  components: {
    ReviewItem,
  },
  watch: {
    product: {
      deep: true,
      handler() {
        this.sync();
      },
    },
  },
};
</script>
